import { Action } from '@ngrx/store';
import { IProfilePlan } from '@app/profile/main/details';

export enum ProfilePlanActionTypes {
    GET = '[ProfilePlan] Get profile plan',
    UPDATE = '[ProfilePlan] Update profile plan',
    CLEAR = '[ProfilePlan] Clear profile plan',
    EMERGENCY = '[ProfilePlan] EMERGENCY profile plan'
}

export class ActionProfilePlanGet implements Action {
    readonly type = ProfilePlanActionTypes.GET;
    constructor() { }
}

export class ActionProfilePlanUpdate implements Action {
    readonly type = ProfilePlanActionTypes.UPDATE;
    constructor(public payload: {profilePlan: IProfilePlan}) { }
}

export class ActionProfilePlanClear implements Action {
    readonly type = ProfilePlanActionTypes.CLEAR;
    constructor() { }
}

export class ActionProfilePlanEmergency implements Action {
  readonly type = ProfilePlanActionTypes.EMERGENCY;
  constructor() { }
}

export type ProfilePlanActions =
    ActionProfilePlanGet |
    ActionProfilePlanUpdate |
    ActionProfilePlanClear |
    ActionProfilePlanEmergency;
